import type { ApolloCache } from "@apollo/client/cache"

import { QueryTypename } from "shared/api/types"
import { sortByPositionAndUpdateIndex } from "shared/lib/sorting/sortByPosition"

import {
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables
} from "entities/projects/graphql/queries.generated"

import { readProjects } from "./readProjects"

export function restoreProjectSorting(cache: ApolloCache<object>) {
  const projects = readProjects(cache)

  if (projects) {
    cache.writeQuery<ProjectsQuery, ProjectsQueryVariables>({
      data: {
        projects: sortByPositionAndUpdateIndex(projects),
        __typename: QueryTypename
      },
      query: ProjectsDocument
    })
  }
}
